import { createContext, useContext, useEffect } from 'react'

/**
 * 창(`Modal`) 안에 든 화면이 창에게 말하는 길(eric 2026-09-30 「추가 창을 팝업으로」).
 *
 * 페이지 한 장짜리 폼(`DetailPage`)을 **그대로** 창 안에 넣기 위한 것이다 — 폼 쪽이 창을 몰라도 되게
 * 두 가지만 흘린다.
 * - `footer` — 창 바닥 줄 자리. 폼의 버튼(취소 · 만들기)이 여기로 옮겨 가 본문이 스크롤돼도 늘 보인다
 * - `setBusy` — 저장 중이면 창이 × · Esc · 바깥 누름으로 닫히지 않는다
 *
 * 창 밖(페이지 · 서랍)에서는 `null` 이다 — 그때 폼은 종전 그대로 제 머리줄과 버튼을 그린다.
 * ⚠ 컴포넌트와 파일을 나눈 것은 한 파일이 컴포넌트만 내보내야 핫리로드가 성립해서다.
 */
export type ModalFrame = {
  footer: HTMLElement | null
  setBusy: (busy: boolean) => void
}

export const ModalFrameContext = createContext<ModalFrame | null>(null)

/** 지금 창 안인가. 창 밖이면 `null` */
export function useModalFrame(): ModalFrame | null {
  return useContext(ModalFrameContext)
}

/** 저장 중을 창에 알린다. 창 밖에서는 아무 일도 안 한다 */
export function useModalBusy(busy: boolean): void {
  const frame = useModalFrame()
  const setBusy = frame?.setBusy
  useEffect(() => {
    if (setBusy === undefined) return undefined
    setBusy(busy)
    return () => setBusy(false)
  }, [setBusy, busy])
}
